/** Sélecteur de période — 24 h / 7 j / 30 j / personnalisé. */

import { useState } from 'react';
import { customRange, presetRange } from '../lib/range';
import type { Range } from '../lib/range';
import { toDateInput } from '../lib/format';

export function RangePicker({
  range,
  onChange,
}: {
  range: Range;
  onChange: (r: Range) => void;
}): React.ReactElement {
  const today = toDateInput(new Date());
  const [open, setOpen] = useState(range.key === 'custom');
  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);
  const [error, setError] = useState<string | null>(null);

  const applyCustom = (): void => {
    const next = customRange(from, to);
    if (!next) {
      // Le serveur refuse déjà les plages > 400 jours en 400 ; on l'annonce ici
      // pour éviter un aller-retour réseau qui finira en message d'erreur rouge.
      setError('Plage invalide : la fin doit suivre le début, et la durée rester sous 400 jours.');
      return;
    }
    setError(null);
    onChange(next);
  };

  return (
    <div className="stack" style={{ gap: 8 }}>
      <div className="toolbar">
        <div className="seg" role="group" aria-label="Période d'observation">
          {(['24h', '7d', '30d'] as const).map((key) => (
            <button
              key={key}
              type="button"
              aria-pressed={range.key === key}
              onClick={() => {
                setOpen(false);
                setError(null);
                onChange(presetRange(key));
              }}
            >
              {key === '24h' ? "Aujourd'hui" : key === '7d' ? '7 jours' : '30 jours'}
            </button>
          ))}
          <button type="button" aria-pressed={range.key === 'custom'} onClick={() => setOpen((v) => !v)}>
            Choisir des dates
          </button>
        </div>
      </div>

      {open ? (
        <div className="toolbar">
          <label className="field">
            Du
            <input type="date" value={from} max={today} onChange={(e) => setFrom(e.target.value)} />
          </label>
          <label className="field">
            Au
            <input type="date" value={to} max={today} onChange={(e) => setTo(e.target.value)} />
          </label>
          <button type="button" className="btn btn-primary" onClick={applyCustom}>
            Appliquer
          </button>
        </div>
      ) : null}

      {error ? (
        <p className="small" style={{ color: 'var(--c-red)', margin: 0 }}>
          {error}
        </p>
      ) : null}
    </div>
  );
}
